export const FILTER_CHANGE = 'FILTER_CHANGE'

export const changeFilter = (name, value) => ({type: FILTER_CHANGE, name, value})
